import React from 'react'
import { RenderDialogProps } from '../../../../legacy-design-system/action/confirmation-action'
import { ServerBulkActionProps } from '../row-action-list'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import { logError, logSuccess } from '../../../toaster'
import { ConfirmDeleteServerDialog } from './delete-servers-confirm-dialog'
import { ContrastFormattedMessage } from '../../../contrast-formatted-message'

const mutationName = 'deleteServers'

export const deleteServersMutation = gql`
  mutation DeleteServers(
    $organizationID: ID!
    $serverIDs: [ID!]!
    $deleteVulnerabilities: Boolean!
  ) {
    ${mutationName}(
      input: {
        organizationID: $organizationID
        ids: $serverIDs
        deleteVulnerabilities: $deleteVulnerabilities
      }
    ) {
      _placeholder
    }
  }
`

interface MutationData {
  readonly __typename: 'Mutation'
  readonly [mutationName]: {
    readonly _placeholder: boolean
    readonly __typename: 'ServerBulkResponse'
  }
}

interface MutationVariables {
  readonly serverIDs: string[]
  readonly organizationID: string
  readonly deleteVulnerabilities: boolean
}

export function DeleteBulkDialog({
  servers,
  organizationID,
  refetchQueries,
  refresh,
  isOpen,
  closeDialog
}: RenderDialogProps & ServerBulkActionProps) {
  return (
    <Mutation<MutationData, MutationVariables> mutation={deleteServersMutation}>
      {(deleteServers) => {
        return (
          <ContrastFormattedMessage
            id="plural_servers_successfullyDeletedServer"
            values={{ count: servers.length }}
            children={(successMessage) => (
              <ContrastFormattedMessage
                id="plural_servers_errorDeletingServer"
                values={{ count: servers.length }}
                children={(errorMessage) => (
                  <ConfirmDeleteServerDialog
                    organizationID={organizationID}
                    servers={servers}
                    isOpen={isOpen}
                    closeDialog={closeDialog}
                    deleteOperation={(deleteVulnerabilities) => {
                      return deleteServers({
                        refetchQueries,
                        variables: {
                          serverIDs: servers.map((s) => s.id),
                          organizationID,
                          deleteVulnerabilities
                        },
                        optimisticResponse: {
                          [mutationName]: {
                            _placeholder: true,
                            __typename: 'ServerBulkResponse'
                          },
                          __typename: 'Mutation'
                        }
                      })
                        .then(() => {
                          // eslint-disable-next-line @typescript-eslint/no-floating-promises
                          refresh()
                          logSuccess(successMessage)
                        })
                        .catch((error) => {
                          console.error(error)
                          logError(errorMessage)
                          return error
                        })
                    }}
                  />
                )}
              />
            )}
          />
        )
      }}
    </Mutation>
  )
}
